import { ToastProgrammatic as Toast } from 'buefy';

const default_options = {
  duration: 5000
}

export default {
	default(text) {
    if (!helpers.isEmpty(text)) {
      Toast.open(Object.assign({}, default_options, {
        message: text,
  		}));
    }
	},

	notice(text) {
		this.default(text);
	},

	success(text) {
    if (!helpers.isEmpty(text)) {
  		Toast.open(Object.assign({}, default_options, {
        message: text,
        type: 'is-success'
  		}));
    }
	},

	info(text) {
    if (!helpers.isEmpty(text)) {
  		Toast.open(Object.assign({}, default_options, {
        message: text,
        type: 'is-info'
  		}));
    }
	},

	danger(text) {
    if (!helpers.isEmpty(text)) {
  		Toast.open(Object.assign({}, default_options, {
        message: text,
        type: 'is-danger'
  		}));
    }
	},

	error(text) {
		this.danger(text);
	}
};
